import React from 'react';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { BodyLarge } from '@shared/ui/atoms/fonts/Body';

export function LeavePlannerNotEnabled(props: Props) {
  const {t} = useTranslation();
  return (
    <Container>
      <Image src={"/assets/images/spacing-image.svg"} alt={""} />
      <HeadlineSmall style={{marginBottom: 12}}>{t('holidays.leave-planner-disabled-title')}</HeadlineSmall>
      <BodyLarge>{t('holidays.leave-planner-disabled-description')}</BodyLarge>
    </Container>
  )
}

interface Props {
}

const Container = styled.div`
  max-width: 500px;
  margin: 50px auto 200px auto;
`

const Image = styled.img`
  width: 100%;
  margin-bottom: 30px;
`
